// TEEUP-INSIDE 2026-07-03: tiny same-page pub/sub so an inline "game-plan moment" row in the
// Conversation (e.g. "Maya suggested a time") can scroll to AND expand the matching When/Where
// card IN PLACE (spec: this does NOT navigate to a different page/route). No new state library
// pulled in for one signal -- a window CustomEvent is enough and avoids coupling the Conversation
// tree to the WhenWhereCard tree.
export type GameplanFocusType = "when" | "where"

const EVENT_NAME = "teeup-detail:focus-gameplan"

export const focusGameplanCard = (type: GameplanFocusType) => {
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, { detail: { type } })
  )
}

export const subscribeGameplanFocus = (
  cb: (type: GameplanFocusType) => void
) => {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent).detail
    if (detail?.type) cb(detail.type)
  }
  window.addEventListener(EVENT_NAME, handler)
  return () => window.removeEventListener(EVENT_NAME, handler)
}
